"use strict";
/*
 * Created on 09 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>Structure used during processing of uploaded file related to {@link SiteRelease}. Contains the core (relevant) data
 * from uploaded file by user and some derived data to ease feedback processing towards user.</p>
 *
 * @see {@link SiteReleaseUpload} for additional info.
 * @author Jaroslav Sevcik
 * @author JMe
 */


var SiteReleaseUploadedItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteReleaseUploadedItem, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id
   * @param uploadId Corresponds to {@link SiteReleaseUpload.id}.
   * @param pExtId Corresponds to {@link Product.externalId}. The value is required part of uploaded file. It is nullable because we want
   *        to process whole CSV file and then show missing required attributes at once.
   * @param gosExtId Corresponds to {@link GroupOfSites.externalId}. The value is required part of uploaded file. It is nullable because
   *        we want to process whole CSV file and then show missing required attributes at once.
   * @param pValue Value of the price. The value is a required part of the uploaded file. It is nullable because we want to process a
   *        whole CSV file and then show missing required attributes at once.
   * @param pValidFrom Price validity start date. The value is a required part of the uploaded file. It is nullable because we want to
   *        process a whole CSV file and then show missing required attributes at once.
   * @param rowNumber A number of rows within a source file. The value is derived from an uploaded file.
   * @param uploaded The moment a row was uploaded.
   * @param validation A validation result related to the row.
   */
  function SiteReleaseUploadedItem(id, uploadId, pExtId, gosExtId, pValue, pValidFrom, rowNumber, uploaded, validation) {
    var _this;

    _classCallCheck(this, SiteReleaseUploadedItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseUploadedItem).call(this));
    _this.id = id;
    _this.uploadId = uploadId;
    _this.pExtId = pExtId;
    _this.gosExtId = gosExtId;
    _this.pValue = pValue;
    _this.pValidFrom = pValidFrom;
    _this.rowNumber = rowNumber;
    _this.uploaded = uploaded;
    _this.validation = validation;
    return _this;
  }

  return SiteReleaseUploadedItem;
}(DomainObject_1.DomainObject);

exports.SiteReleaseUploadedItem = SiteReleaseUploadedItem;